import * as types from './constants';

export const initialState = {
  dataTable: [],
  loading: false,
  count: 0,
  next: null,
  previous: null,
  curr_page: 1,
  errors_api: {}
};

const actions = {
  // Get Top Performers
  [types.GET_TOP_PERFORMERS_REQUEST]: state => {
    const data = {
      ...state,
      dataTable: [],
      loading: true
    };

    return { ...data };
  },

  [types.GET_TOP_PERFORMERS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      ...payload
    };

    return { ...data };
  },

  [types.GET_TOP_PERFORMERS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GET_TOP_PERFORMERS_RESET]: () => {
    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};